import React from 'react'
import FaqContainer from '../../../Components/Miscellaneous/FAQ'

export default function Faq() {
  return (
    <div className='page-body'>
        <FaqContainer/>
    </div>
  )
}
